import axios from "axios";


var baseURL = "http://localhost:3000/chart";
const instance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json"
  }
});

instance.interceptors.request.use(function(config) {
  const token = localStorage.getItem("auth-token");
  config.headers.Authorization = token ? `${token}` : "";
  return config;
});

export default instance;
